import {seoText} from './catalog-seo.mjs';
export {serializePlantSchema as serializeListingSchema} from './plant-schema.mjs';
const ORIGIN='https://uogorod.ru';
const localUrl=value=>{
 try{const url=new URL(String(value),ORIGIN);return url.origin===ORIGIN&&url.pathname.startsWith('/')?url.href:null;}catch{return null;}
};

// Lists describe only links actually shown on the current page, not unseen results.
export function listingSchema({url,name,description,breadcrumbs=[],items=[],listName,offset=0,order,alternateNames=[],primaryName}){
 const canonical=localUrl(url);if(!canonical||!seoText(name))return null;
 const page={'@type':'CollectionPage','@id':canonical+'#webpage',url:canonical,name:seoText(name),description:seoText(description),inLanguage:'ru-RU'};
 const normalize=value=>seoText(value).toLocaleLowerCase('ru').replace(/ё/g,'е');
 const seen=new Set([normalize(primaryName||name)]);
 const aliases=(Array.isArray(alternateNames)?alternateNames:[]).flatMap(value=>{
  if(typeof value!=='string')return [];
  const text=seoText(value),key=normalize(text);
  if(!text||seen.has(key))return [];
  seen.add(key);return [text];
 });
 if(aliases.length)page.alternateName=aliases;
 const graph=[page];
 const trail=breadcrumbs.flatMap(b=>{
  const item=localUrl(b.href);return item&&seoText(b.title)?[{name:seoText(b.title),item}]:[];
 });
 if(trail.length>=2){
  const breadcrumb={'@type':'BreadcrumbList','@id':canonical+'#breadcrumbs',itemListElement:trail.map((b,i)=>({'@type':'ListItem',position:i+1,...b}))};
  page.breadcrumb={'@id':breadcrumb['@id']};graph.push(breadcrumb);
 }
 const entries=items.flatMap(item=>{
  const href=localUrl(item.url),title=seoText(item.name);
  if(!href||!title)return [];
  return [{'@type':'ListItem',position:0,item:{'@type':['Person','Thing','CollectionPage','Brand'].includes(item.type)?item.type:'WebPage','@id':href,url:href,name:title}}];
 });
 if(entries.length){
  const start=Number.isSafeInteger(offset)&&offset>=0?offset:0;
  entries.forEach((item,i)=>{item.position=start+i+1;});
  const list={'@type':'ItemList','@id':canonical+'#list',name:seoText(listName||name),numberOfItems:entries.length,itemListElement:entries};
  if(order==='descending')list.itemListOrder='https://schema.org/ItemListOrderDescending';
  page.mainEntity={'@id':list['@id']};graph.push(list);
 }
 return {'@context':'https://schema.org','@graph':graph};
}

export const plantListItems=plants=>(plants||[]).map(p=>({type:'Thing',name:p.title,url:'/catalog/product-'+p.id}));

export function catalogListingSchema(seo,options={}){
 if(options.detail)return null; // Individual plant pages already have their own graph.
 const root=seo.canonical.split('?')[0]==='https://uogorod.ru/catalog';
 return listingSchema({url:seo.canonical,name:seo.title,description:seo.description,
  breadcrumbs:options.breadcrumbs||[{title:'Главная',href:'/'},{title:'Каталог',href:'/catalog'},...(!root?[{title:seo.title.replace(/ — Умный Огород$/,''),href:seo.canonical}]:[])],
  items:options.items||[],listName:options.listName,offset:options.offset||0,alternateNames:options.alternateNames,primaryName:options.primaryName});
}

export function participantRankingSchema(data,{periodName='Эта неделя',range='',categoryName='Общий вклад',audienceName='Все участники'}={}){
 return listingSchema({url:'/profiles/ratings',name:'Рейтинг участников',description:[periodName,range,categoryName,audienceName].filter(Boolean).join(' · '),
  breadcrumbs:[{title:'Главная',href:'/'},{title:'Садоводы',href:'/profiles'},{title:'Рейтинг участников',href:'/profiles/ratings'}],
  // Contribution points are not review stars. Do not emit Rating/AggregateRating,
  // private mine/events or a ProfilePage for this multi-person leaderboard.
  items:(data?.rows||[]).filter(r=>/^\d+$/.test(String(r.user_id))).map(r=>({type:'Person',name:r.name||r.nickname,url:'/profiles/'+r.user_id})),
  listName:'Участники по убыванию баллов · '+periodName,order:'descending'});
}
